export function getMyQuizzes(state) {
  return state.myQuizzes;
}

export function getQuiz(state) {
  return state.quiz;
}

export function isLoadingQuiz(state) {
  return state.isLoadingQuiz;
}

export function isLoadingMyQuizzes(state) {
  return state.isLoadingMyQuizzes;
}

export function getQuizError(state) {
  return state.error;
}

export function getTotalMyQuizzes(state) {
  return state.total;
}



// WEBPACK FOOTER //
// ./src/app/my-quizzes/store/getters.js